import { render, staticRenderFns } from "./ReviewslistAll.vue?vue&type=template&id=0d0fc140&scoped=true"
import script from "./ReviewslistAll.vue?vue&type=script&lang=js"
export * from "./ReviewslistAll.vue?vue&type=script&lang=js"
import style0 from "./ReviewslistAll.vue?vue&type=style&index=0&id=0d0fc140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0fc140",
  null
  
)

export default component.exports